import { ClientCRMRepo } from "@services/clients/clientCRM.repo";

export class AddManagementFeeModalController {
    public client: any;
    public clientNumber: string;
    public managementFee: any = {};
    public dropdownOptions: any = {};
    public isEditMode: boolean = false;
    public isLoading: boolean = false;
    public title: string = 'New Management Fee';
    public acceptButtonText: string = 'Save';
    public cancelButtonText: string = 'Cancel';
    public clientPortfolioAccounts: any[] = [];

    /** @ngInject */
    constructor(
        private $mdDialog: angular.material.IDialogService,
        private clientCRMRepo: ClientCRMRepo
    ) {}

    public $onInit(): void {
        // Check if we're in edit mode
        this.isEditMode = this.managementFee && this.managementFee.id ? true : false;
        
        if (this.isEditMode) {
            this.title = 'Edit Management Fee';
        } else {
            // Initialize with default values for new management fee
            this.managementFee = {
                portfolioNumber: '',
                accountNumber: '',
                bank: undefined,
                currency: undefined,
                dateWhichStartedToBeManaged: undefined,
                dateOnWhichEnded: undefined,
                managementFeeType: undefined,
                comments: '',
                startDateFeeType: '',
                endDateFeeType: '',
                amendmentToManagementFee: '',
                setupFee: undefined
            };
        }
        
        // Load client portfolio accounts
        this.loadClientPortfolioAccounts();
    }

    public save(): void {
        // Validate required fields
        if (!this.managementFee.portfolioNumber) {
            console.log('Error: Portfolio number is required');
            return;
        }
        this.$mdDialog.hide(this.managementFee);
    }

    public cancel(): void {
        this.$mdDialog.cancel();
    }

    // Load client portfolio accounts
    private loadClientPortfolioAccounts(): void {
        if (this.client && this.client.id) {
            this.isLoading = true;
            this.clientCRMRepo.getClientPortfolioAccounts(this.clientNumber)
                .then((response: any) => {
                    this.clientPortfolioAccounts = response.data || [];
                })
                .catch((error) => {
                    console.error('Error loading client portfolio accounts:', error);
                    this.clientPortfolioAccounts = [];
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
}

export const AddManagementFeeModalComponent: angular.IComponentOptions = {
    template: require('./add-management-fee-modal.html'),
    controller: AddManagementFeeModalController,
    controllerAs: '$ctrl',
    bindings: {
        client: '<',
        managementFee: '=',
        dropdownOptions: '<',
        clientNumber: '<'

    }
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/portfolio/modals/add-management-fee-modal.ts